//import React, { useState, useEffect } from 'react';
import { ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';
import { format } from 'date-fns'
import { InfoBox } from './Components'
import { MdArrowBack, MdArrowForward } from "react-icons/md";
import PieCharts from "./PieCharts";
// import { DataRefresh } from "./Components";
//import sampleData from "./sample_data.json"




const processData = (data) => {
  return Object.keys(data).map((time) => ({
    time,
    totalHour: data[time].total_hour,
    price: data[time].price,
    cost: data[time].cost,
    dayAvg: data[time].day_avg,
    belowAvg: data[time].below_avg || false
  }));
};



const isBeforeToday = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset hours, minutes, seconds, and ms for an accurate comparison
    return date < today;
  };  

// Modified HeatingCharts component that chooses between regular and PV charts
const HeatingCharts = ({ currentDate, onPreviousDate, onNextDate, data, error, errorState }) => {
  
  //data = sampleData

  if (!data) {
    return <div>Loading...</div>;
  }

  const { metadata, total_consumption } = data;

  // Check if PV data is available by looking for solar-related fields
  const hasPVData = Object.values(total_consumption).some(hour => 
    hour.panel_prod !== undefined || 
    hour.consumption_from_panels !== undefined || 
    hour.total_sold_hour !== undefined
  );

  const thermostatDetails = metadata.thermostat_details;
  const actorDetails = metadata.actor_details ? metadata.actor_details : null;
  
  return (
    <>
      <div className="center-header">
        <h2>Electricity Price, Total Consumption and Cost {hasPVData && 'with Solar Production - BETA'}</h2>
      </div>  
      <div className="center-text">
        <h3><button onClick={onPreviousDate}><MdArrowBack /></button> {metadata.date} {isBeforeToday(currentDate) && <button onClick={onNextDate}><MdArrowForward /></button>} </h3>
      </div>
      
      {hasPVData ? (
        <PVSummaryChart summaryData={total_consumption} metadata={metadata}/>
      ) : (
        <SummaryChart summaryData={total_consumption} metadata={metadata}/>
      )}
      
      {hasPVData && data.pv_data && (
        <PVOptimizationChart pvData={data.pv_data} metadata={metadata}/>
      )}
      <p></p>
      
      <PieCharts thermostatDetails={thermostatDetails} actorDetails={actorDetails} />
      
      <div className="center-text"><h3>Thermostat Details</h3></div>
     
      {metadata.thermostat_id_list.map(thermostatId => (
        thermostatId.includes('#config') ? (
          <ConfigChart key={thermostatId} data={data} thermostatId={thermostatId} metadata={metadata} />
        ) : (
          <ThermostatChart key={thermostatId} data={data} thermostatId={thermostatId} metadata={metadata} />
        )
      ))}
      
      {metadata.actor_id_list.length > 0 ? (
        <>
          <div className="center-text"><h3>Consumption Control Details</h3></div>
          {metadata.actor_id_list.map(actorId => (
            <ConsumptionChart key={actorId} data={data} actorId={actorId} metadata={metadata} />
          ))}
        </>
      ) : null}
    </>
  );
};


const customizedLegend = [
  { value: 'Total Consumption - below day average', type: 'square', color: '#90ee90' },
  { value: 'Total Consumption - above day average', type: 'square', color: '#ff6961' },
  { value: 'Electricity Price', type: 'line', color: '#ff7300' },
  { value: 'Day Average', type: 'line', color: '#ffa089' }
];

const CustomBarShapeTotals = (props) => {
  const { x, y, width, height, payload } = props;
  const customFill = payload.belowAvg ? '#90ee90' : '#ff6961';  // Green if reserve heating, otherwise default color
  return <rect x={x} y={y} width={width} height={height} fill={customFill} />;
};


const SummaryChart = ({ summaryData, metadata }) => {
  
  
  const processedSummarydData = processData(summaryData);
  //const metadata = data.metadata;

  const summaryDataPoints = [
    { label: "Total Consumption", value: `${metadata.total_consumption} kWh` },  // Assuming units are kWh, add if needed

      ...(metadata.consumption_below_avg !== undefined && metadata.consumption_above_avg !== undefined ? 
        [{ label: "Consumption below avg / above avg", value: `${metadata.consumption_below_avg} / ${metadata.consumption_above_avg} kWh` }] 
        : []
      ),
    { label: "Total Cost", value: `c ${metadata.total_cost.toFixed(2)}` },  // Ensure formatting to two decimal places for currency  
    { label: "Average Spot Price (full 24h)", value: `c ${metadata.spot_avg}` },
    { label: "Realised Average Price", value: `c ${metadata.realised_avg}` },
    { label: "Estimated savings, for full days only. Savings = (Total Consumption x Avg Spot Price) - Total Cost", value: `c ${metadata.estimated_saving}` },
    { label: "Average outdoor temperature", value: `${metadata.outdoor_temp_avg} \u00b0C` },
  ];

// Line to plot the hourly cost  
//       <Line type="step" yAxisId="right" dataKey="cost" name="Hourly Cost" stroke="#00c49f" strokeWidth={2}/>
// fill="#8884d8"
  return (
    <>
    
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart data={processedSummarydData} margin={{ top: 20, right: 30, bottom: 20, left: 20 }}>
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis dataKey="time" name="Hour" tickFormatter={(tickItem) => format(new Date(tickItem), 'HH')}  />
        <YAxis yAxisId="left" label={{ value: 'Consumption (kWh)', angle: 90, position: 'insideLeft' }} />
        <YAxis yAxisId="right" orientation="right" label={{ value: 'Price/Cost (c)', angle: 90, position: 'insideRight' }} />

        <Tooltip />
        <Legend payload={customizedLegend} />
        <Bar yAxisId="left" dataKey="totalHour" name="Total Consumption"  shape={<CustomBarShapeTotals/>} barSize={20} />
        <Line type="step" yAxisId="right" dataKey="price" name="Electricity Price" stroke="#ff7300" strokeWidth={2}/>
        <Line yAxisId="right" dataKey="dayAvg" name="Day Average" stroke="#ffa089" strokeDasharray="8" strokeWidth={2} dot={false}/>
 
      </ComposedChart>
    </ResponsiveContainer>
    <div>
      <InfoBox title="Summary" dataPoints={summaryDataPoints} />
    </div>
    </>
  );
};


const ThermostatChart = ({ data, thermostatId, metadata}) => {
  if (!data) return null;
 
  
  const deviceColors = [
    '#8884d8', // Purple
    '#82ca9d', // Green
    '#ffc658', // Yellow
    '#ff7300', // Orange
    '#f45b5b', // Red
    '#00c49f', // Teal
    '#a4de6c', // Light green
    '#9053c7'  // Orchid
  ];



const processData = (thermostatData) => {
  return Object.keys(thermostatData).map(key => {
    const hourlyByDevice = thermostatData[key].hourly_by_device || {};
    const processedData = {
      time: key,
      targetTemp: thermostatData[key].target_temp,
      currentTemp: thermostatData[key].current_temp,
      hourlyConsumption: thermostatData[key].hourly_consumption || 0,
      ...hourlyByDevice,
      reserve_heating: thermostatData[key].reserve_heating || false  // Add the charging flag
    };
    //console.log(processedData)
    return processedData;
  });
};




  const thermostatName = metadata['thermostat_details'][thermostatId]['name'];
  const chartData = processData(data[thermostatId]);
  const infoData = metadata.thermostat_details[thermostatId];
  

  
  const thermostatInfo = [
    { label: "Total Consumption", value: `${infoData.total_consumption} kWh` },  // Assuming units are kWh, add if needed
    { label: "Average temperature", value: `${infoData.temp_avg}\u00b0C` },
    { label: "Min temperature", value: `${infoData.min_temp} \u00b0C` },
    { label: "Max temperature", value: `${infoData.max_temp} \u00b0C` }
  ];

  // Get the list of device keys
  const deviceKeys = Object.keys(chartData[0]).filter(key => 
    key !== 'time' && key !== 'targetTemp' && key !== 'currentTemp' && key !== 'hourlyConsumption'  && key !== 'reserve_heating'
  );

const CustomBarShape = (props) => {
  const { x, y, width, height, payload, index } = props;
  const customFill = payload.reserve_heating ? '#228b22' : deviceColors[index % deviceColors.length];  // Green if reserve heating, otherwise default color
  return <rect x={x} y={y} width={width} height={height} fill={customFill} />;
};

// Check if any entry in chartData has reserve_heating as true
const chargingOccurred = chartData.some(entry => entry.reserve_heating === true);

// Create a custom legend that includes both device keys and temperature lines
const customizedLegend = [
  // Add device keys to the legend
  ...deviceKeys.map((deviceKey, index) => ({
    value: deviceKey,
    type: 'square',
    color: deviceColors[index % deviceColors.length], // Regular color for non-charging
  })),
  // Conditionally add Charging legend if charging occurred
  ...(chargingOccurred
    ? deviceKeys.map((deviceKey, index) => ({
        value: `${deviceKey} - Charging`,
        type: 'square',
        color: '#228b22', // Green for charging
      }))
    : []),
  // Manually add Target Temperature and Measured Temperature
  { value: 'Target Temperature', type: 'line', color: '#8884d8' },
  { value: 'Measured Temperature', type: 'line', color: '#82ca9d' }
];


//<Legend payload={customizedLegend} />

  return (
    <div>
      
      <InfoBox title={thermostatName} dataPoints={thermostatInfo} />
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={chartData}>
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis 
            dataKey="time" 
            name="Hour" 
            tickFormatter={(tickItem) => {
              const date = new Date(tickItem);
              return date.getMinutes() === 0 ? format(date, 'HH') : ''; // Show only full-hour labels
            }} 
            ticks={chartData
              .map((d) => d.time)
              .filter((time) => new Date(time).getMinutes() === 0)} // Show ticks only for full hours
            interval={0} // Force all specified ticks to appear
          />

          <YAxis yAxisId="left" orientation="left" label={{ value: 'Consumption (kWh)', angle: 90, position: 'insideLeft' }} domain={['auto', 'auto']} stroke="#413ea0"/>
          <YAxis yAxisId="right" orientation="right" label={{ value: 'Temperature (C)', angle: 90, position: 'insideRight' }} domain={[10, 'auto']} stroke="#8884d8"/>
          <Tooltip 
            formatter={(value, name, props) => {
            
              // Apply "Charging heat retainer" only to the device and consumption rows
              if (props.payload.reserve_heating && name !== 'Target Temperature' && name !== 'Measured Temperature') {
                return [`${value} - Charging heat retainer`, name];
              }
              return [value, name];
              
            }} 
          />
        {/* Custom Legend */}
        <Legend payload={customizedLegend.map(item => ({ value: item.value, type: item.type, color: item.color }))} />

        
        {/* Temperature Lines */}
        <Line yAxisId="right" type="stepAfter" dataKey="targetTemp" name="Target Temperature" stroke="#8884d8" strokeWidth={2} dot={false} />
        <Line yAxisId="right" type="monotone" dataKey="currentTemp" name="Measured Temperature" stroke="#82ca9d" strokeWidth={2} dot={false} />

          {/* Total Consumption Bar 
          <Bar yAxisId="left" dataKey="hourlyConsumption" name="Total Consumption" fill="#413ea0" /> */}
          {/* Stacked Bars for Device Consumption */}
          {deviceKeys.map((deviceKey, index) => (
            <Bar 
              yAxisId="left" 
              key={deviceKey} 
              dataKey={deviceKey} 
              name={deviceKey}  // Use the device name for the legend
              stackId="a" 
              shape={<CustomBarShape index={index} />}  // Use the custom shape to render bars  // Change color if charging
            // fill={deviceColors[index % deviceColors.length]}  // Use the colors array
            />
          ))}
          {/* Temperature Lines 
          <Line yAxisId="right" type="stepAfter" dataKey="targetTemp" name="Target Temperature" stroke="#8884d8" strokeWidth={2} dot={false} />
          <Line yAxisId="right" type="monotone" dataKey="currentTemp" name="Measured Temperature" stroke="#82ca9d" strokeWidth={2} dot={false} />*/}
        </ComposedChart>
      </ResponsiveContainer>
      <p></p>
    </div>
  );

// deviceColors[index % deviceColors.length]

};


const ConfigChart = ({ data, thermostatId, metadata}) => {
  if (!data) return null;
  
  
  const deviceColors = [
    '#8884d8', // Purple
    '#82ca9d', // Green
    '#ffc658', // Yellow
    '#ff7300', // Orange
    '#f45b5b', // Red
    '#00c49f', // Teal
    '#a4de6c', // Light green
    '#9053c7'  // Orchid
  ];



const processData = (thermostatData) => {
  return Object.keys(thermostatData).map(key => {
    const processedData = {
      time: key,
      targetTemp: thermostatData[key].target_temp,
      calibration: thermostatData[key].calibration,
      fanSpeed: thermostatData[key].fan_level,
      outdoorTemp: thermostatData[key].outdoor_temp
    };
    //console.log(processedData)
    return processedData;
  });
};




  const thermostatName = metadata.thermostat_details[thermostatId].name;
  const chartData = processData(data[thermostatId]);
  const infoData = metadata.thermostat_details[thermostatId];

  
  const configInfo = [
    { label: "AHP Target temperature", value: `${infoData.target_temp} \u00b0C` },  // Assuming units are kWh, add if needed
    { label: "Calibration value", value: `${infoData.calibration}\u00b0C` },
    { label: "Fan speed", value: `${infoData.fan_level}` },
    { label: "Outdoor temperature", value: `${infoData.outdoor_temp} \u00b0C` },
    { label: "Settings at", value: `${infoData.timestamp}` }
  ];
  


  return (
    <div>
      <InfoBox title={thermostatName} dataPoints={configInfo} />
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={chartData}>
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis 
            dataKey="time" 
            name="Hour" 
            tickFormatter={(tickItem) => {
              const date = new Date(tickItem);
              return date.getMinutes() === 0 ? format(date, 'HH') : ''; // Show only full-hour labels
            }} 
            ticks={chartData
              .map((d) => d.time)
              .filter((time) => new Date(time).getMinutes() === 0)} // Show ticks only for full hours
            interval={0} // Force all specified ticks to appear
          />

          <YAxis yAxisId="left" orientation="left" label={{ value: 'Outdoor temperature (C)', angle: 90, position: 'insideLeft' }} domain={['auto', 'auto']} stroke="#413ea0"/>
          {/*}<YAxis yAxisId="rightTargetTemp" orientation="right" label={{ value: 'AHP Target temperature (C)', angle: 90, position: 'insideRight' }} domain={[15, 35]} stroke="#8884d8"/>
          <YAxis yAxisId="rightCalib" orientation="right" label={{ value: 'AHP Calibration (C)', angle: 90, position: 'insideRight' }} domain={[-2, 10]} stroke="#8884d8"/>
          <YAxis yAxisId="rightFanSpeed" orientation="right" label={{ value: 'AHP Fan speed', angle: 90, position: 'insideRight' }} domain={[0, 3]} stroke="#8884d8"/> */}
          <YAxis yAxisId="right" orientation="right" label={{ value: 'AHP Settings', angle: 90, position: 'insideRight' }} domain={['auto', 'auto']} stroke="#8884d8"/>
        
            {/* Temperature Lines */}
          <Line yAxisId="left" type="monotone" dataKey="outdoorTemp" name="Outdoor Temperature" stroke="#8884d8" strokeWidth={2} dot={false} />
          <Line yAxisId="right" type="stepAfter" dataKey="targetTemp" name="AHP Target Temperature" stroke="#82ca9d" strokeWidth={2} dot={false} />
          <Line yAxisId="right" type="stepAfter" dataKey="calibration" name="AHP Calibration" stroke="#ffc658" strokeWidth={2} dot={false} />
          <Line yAxisId="right" type="stepAfter" dataKey="fanSpeed" name="AHP Fan Speed" stroke="#ff7300" strokeWidth={2} dot={false} />
          <Tooltip/>
          <Legend/>
          
        </ComposedChart>
      </ResponsiveContainer>
      <p></p>
    </div>
  );

// deviceColors[index % deviceColors.length]


};

const ConsumptionChart = ({ data, actorId, metadata}) => {
  if (!data) return null;
{/* 
  const processData = (actorData) => {
    return Object.keys(actorData).map(key => {
      const processedData = {
        time: key,
        output: actorData[key].output,
        consumption: actorData[key].hourly_consumption,
        override: actorData[key].override || 0,
        zeroLine: 0 // Constant zero line
      };
      
      // Only add pv_output if it exists in the data
      if (actorData[key].pv_output !== undefined) {
        processedData.pv_output = actorData[key].pv_output;
      }
      
      return processedData;
    });
  };
*/}

const processData = (actorData) => {
  return Object.keys(actorData).map(key => {
    const hasPvOutput = actorData[key].pv_output !== undefined && actorData[key].pv_output !== 0;
    
    const processedData = {
      time: key,
      output: hasPvOutput ? 0 : actorData[key].output, // Set output to 0 if pv_output is not zero
      consumption: actorData[key].hourly_consumption,
      override: actorData[key].override || 0,
      zeroLine: 0 // Constant zero line
    };
    
    // Only add pv_output if it exists in the data
    if (actorData[key].pv_output !== undefined) {
      processedData.pv_output = actorData[key].pv_output;
    }
    
    return processedData;
  });
};

  const actorName = metadata.actor_details[actorId].name ? metadata.actor_details[actorId].name : 'unknown';
  const chartData = processData(data[actorId]);
  const infoData = metadata.actor_details[actorId];
  
  const configInfo = [
    { label: "Total consumption", value: `${infoData.total_consumption} kWh` },
    { label: "Total cost", value: `${infoData.total_cost} c` },
    { label: "Configuration profile", value: `${infoData.profile}` }
  ];
  
  return (
    <div>
      <InfoBox title={actorName} dataPoints={configInfo} />
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={chartData}>
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis dataKey="time" name="Hour" tickFormatter={(tickItem) => format(new Date(tickItem), 'HH')} interval={3} />
          <YAxis yAxisId="left" orientation="left" label={{ value: 'Consumption (kWh)', angle: 90, position: 'insideLeft' }} domain={['auto', 'auto']} stroke="#413ea0"/>
          <YAxis yAxisId="right" orientation="right" label={{ value: 'Output', angle: 90, position: 'insideRight' }} domain={['auto', 'auto']} stroke="#8884d8"/>
        
          {/* Consumption Lines */}
          <Line yAxisId="right" type="stepAfter" dataKey="output" name="Output" stroke="#82ca9d" strokeWidth={2} dot={false} />
          <Line yAxisId="right" type="stepAfter" dataKey="override" name="Override" stroke="#FFA500" strokeWidth={2} dot={false} />
          
          {/* PV Output Line - Dark Yellow, only rendered if pv_output exists in data */}
          {chartData.some(item => item.pv_output !== undefined) && (
            <Line 
              yAxisId="right" 
              type="stepAfter" 
              dataKey="pv_output" 
              name="PV Output" 
              stroke="#B8860B" 
              strokeWidth={2} 
              dot={false} 
            />
          )}
          
          <Bar yAxisId="left" dataKey="consumption" name="Hourly Consumption" fill='#8884d8' barSize={20} />
          
          {/* Zero Line - styled like an x-axis and hidden from legend */}
          <Line 
            yAxisId="right" 
            type="monotone" 
            dataKey="zeroLine" 
            name="Zero Line" 
            stroke="#666"
            strokeWidth={2}
            
            dot={false} 
            legendType="none"
            isAnimationActive={false}
          />
          
          <Tooltip 
            content={({ active, payload, label }) => {
              if (active && payload && payload.length) {
                // Filter out the Zero Line from the tooltip payload
                const filteredPayload = payload.filter(entry => entry.dataKey !== 'zeroLine');
                
                // If we have items to show after filtering
                if (filteredPayload.length > 0) {
                  return (
                    <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                      <p className="label">{`Time: ${format(new Date(label), 'HH:mm')}`}</p>
                      {filteredPayload.map((entry, index) => (
                        <p key={`item-${index}`} style={{ color: entry.color }}>
                          {`${entry.name}: ${entry.value}`}
                        </p>
                      ))}
                    </div>
                  );
                }
              }
              return null;
            }}
          />
          <Legend />
        </ComposedChart>
      </ResponsiveContainer>
      <p></p>
    </div>
  );
};

// PV SUMMARY CHART
// New PV-enabled summary chart component
const PVSummaryChart = ({ summaryData, metadata }) => {
  
  const processedPVData = processPVData(summaryData);

  // PV-specific summary data points
  const pvSummaryDataPoints = [
    { label: "Total Consumption", value: `${metadata.total_consumption} kWh` },
    ...(metadata.total_reveived_kwh !== undefined ? 
      [{ label: "Energy from Grid / Energy to Grid", value: `${metadata.total_reveived_kwh.toFixed(2)} / ${metadata.total_sold_kwh} kWh` }] 
      : []
    ),
    ...(metadata.total_panel_prod_for_day !== undefined ? 
      [{ label: "Solar Production", value: `${metadata.total_panel_prod_for_day.toFixed(2)} kWh` }] 
      : []
    ),
    ...(metadata.consumption_below_avg !== undefined && metadata.consumption_above_avg !== undefined ? 
      [{ label: "Grid energy below avg / above avg", value: `${metadata.consumption_below_avg} / ${metadata.consumption_above_avg} kWh` }] 
      : []
    ),
    ...(metadata.total_income !== undefined ? 
      [{ label: "Total Income from Solar Sales", value: `c ${metadata.total_income.toFixed(2)}` }] 
      : []
    ),
    ...(metadata.total_cost_of_received !== undefined ? 
      [{ label: "Cost of Grid Energy", value: `c ${metadata.total_cost_of_received.toFixed(2)}` }] 
      : []
    ),
    { label: "Net Cost", value: `c ${metadata.total_cost.toFixed(2)}` },
    { label: "Average Spot Price (full 24h)", value: `c ${metadata.spot_avg}` },
    { label: "Realised Average Price", value: `c ${metadata.realised_avg}` },
    { label: "Estimated savings, for full days only. Savings = (Total Consumption x Avg Spot Price) - Total Cost", value: `c ${metadata.estimated_saving}` },
    { label: "Average outdoor temperature", value: `${metadata.outdoor_temp_avg} \u00b0C` },
  ];

  return (
    <>
<ResponsiveContainer width="100%" height={400}>
        <ComposedChart data={processedPVData} margin={{ top: 20, right: 30, bottom: 20, left: 20 }}>
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis dataKey="time" name="Hour" tickFormatter={(tickItem) => format(new Date(tickItem), 'HH')} />
          <YAxis yAxisId="left" label={{ value: 'Energy (kWh)', angle: 90, position: 'insideLeft' }} />
          <YAxis yAxisId="right" orientation="right" label={{ value: 'Price/Cost (c)', angle: 90, position: 'insideRight' }} />

          <Tooltip content={<CustomPVTooltip />} />
          <Legend payload={customizedPVLegend} />
          
          {/* Consumption bars - stacked by source */}
          <Bar yAxisId="left" dataKey="gridConsumption" name="Grid Consumption" stackId="consumption" 
               shape={CustomBarShapeWithColor({ baseColor: '#4caf50' })} barSize={15} />
          <Bar yAxisId="left" dataKey="solarConsumption" name="Solar Consumption" stackId="consumption" 
               shape={CustomBarShapeWithColor({ baseColor: '#81c784', aboveAvgColor: '#81c784' })} barSize={15} />
          
          {/* Sold energy bars - separate, positive values */}
          <Bar yAxisId="left" dataKey="soldEnergy" name="Energy Sold" 
               shape={CustomBarShapeWithColor({ baseColor: '#ff9800', aboveAvgColor: '#ff9800' })} barSize={15} />
          
          {/* Price lines */}
          <Line type="step" yAxisId="right" dataKey="price" name="Electricity Price" stroke="#ff7300" strokeWidth={2}/>
          <Line yAxisId="right" dataKey="dayAvg" name="Day Average" stroke="#ffa089" strokeDasharray="8" strokeWidth={2} dot={false}/>
        </ComposedChart>
      </ResponsiveContainer>
      <div>
        <InfoBox title="Solar Summary" dataPoints={pvSummaryDataPoints} />
      </div>
    </>
  );
};

// Data processing function for PV data
const processPVData = (summaryData) => {
  return Object.entries(summaryData).map(([time, data]) => {
    const totalHour = data.total_hour || 0;
    const solarConsumption = data.consumption_from_panels || 0;
    const gridConsumption = totalHour - solarConsumption;
    const soldEnergy = data.total_sold_hour || 0;
    
    return {
      time: new Date(time),
      totalHour,
      solarConsumption,
      gridConsumption: Math.max(0, gridConsumption), // Ensure no negative values
      soldEnergy,
      price: data.price,
      dayAvg: data.day_avg,
      belowAvg: data.below_avg,
      cost: data.cost,
      income: data.income || 0
    };
  });
};

// Configurable custom bar shape factory
const CustomBarShapeWithColor = ({ baseColor, aboveAvgColor = '#ff6961' }) => (props) => {
  const { x, y, width, height, payload } = props;
  const customFill = payload.belowAvg ? baseColor : aboveAvgColor;
  return <rect x={x} y={y} width={width} height={height} fill={customFill} />;
};

// Custom tooltip for PV chart
const CustomPVTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const hour = format(new Date(label), 'HH:mm');
    
    return (
      <div style={{
        backgroundColor: 'white',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>{`Hour: ${hour}`}</p>
        <p style={{ margin: '4px 0', color: '#4caf50' }}>
          {`Grid Consumption: ${data.gridConsumption.toFixed(3)} kWh`}
        </p>
        <p style={{ margin: '4px 0', color: '#81c784' }}>
          {`Solar Consumption: ${data.solarConsumption.toFixed(3)} kWh`}
        </p>
        <p style={{ margin: '4px 0', fontWeight: 'bold' }}>
          {`Total Consumption: ${data.totalHour.toFixed(3)} kWh`}
        </p>
        {data.soldEnergy > 0 && (
          <p style={{ margin: '4px 0', color: '#ff9800' }}>
            {`Energy Sold: ${data.soldEnergy.toFixed(3)} kWh`}
          </p>
        )}
        <p style={{ margin: '4px 0', color: '#ff7300' }}>
          {`Price: ${data.price} c/kWh`}
        </p>
        {data.cost !== undefined && (
          <p style={{ margin: '4px 0' }}>
            {`Net Cost: c ${data.cost.toFixed(2)}`}
          </p>
        )}
        {data.income > 0 && (
          <p style={{ margin: '4px 0', color: '#ff9800' }}>
            {`Income: c ${data.income.toFixed(2)}`}
          </p>
        )}
      </div>
    );
  }
  return null;
};

// Custom legend for PV chart
const customizedPVLegend = [
  { value: 'Grid Consumption', type: 'rect', color: '#4caf50' },
  { value: 'Solar Consumption', type: 'rect', color: '#81c784' },
  { value: 'Energy Sold', type: 'rect', color: '#ff9800' },
  { value: 'Electricity Price', type: 'line', color: '#ff7300' },
  { value: 'Day Average', type: 'line', color: '#ffa089' }
];



const PVOptimizationChart = ({ pvData, metadata }) => {
  
  const processedOptimizationData = processPVOptimizationData(pvData);

  return (
    <>
      <div className="center-header">
        <h2>Solar Power Optimization - Device Control</h2>
      </div>
      
      <ResponsiveContainer width="100%" height={400}>
        <ComposedChart data={processedOptimizationData} margin={{ top: 20, right: 30, bottom: 60, left: 20 }}>
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis dataKey="time" name="Time" tickFormatter={(tickItem) => format(new Date(tickItem), 'HH:mm')} />
          <YAxis label={{ value: 'Power (W) / Energy (kWh)', angle: 90, position: 'insideLeft' }} />

          <Tooltip content={<CustomOptimizationTooltip />} />
          <Legend payload={customizedOptimizationLegend} />

          {/* Panel power line (green) */}
          <Line type="stepAfter" dataKey="panelPower" name="Panel Power" stroke="#82ca9d" strokeWidth={2} dot={false} />
          
          {/* Grid power line (blue) */}
          <Line type="stepAfter" dataKey="gridPower" name="Grid Power" stroke="#8884d8" strokeWidth={2} dot={false} />
          
          {/* Device capacity as line (orange) */}
          <Line type="stepAfter" dataKey="totalDevicePower" name="Device Capacity" stroke="#ffb74d" strokeWidth={2} dot={false} />
          
          {/* Actual panel consumption as bars */}
          <Bar dataKey="actualPanelConsumption" name="Actual Panel Consumption" 
               fill="#64b5f6" barSize={12} />
               
          {/* Reference line at zero */}
          <ReferenceLine y={0} stroke="#666" strokeWidth={2} strokeDasharray="5 5" />
        </ComposedChart>
      </ResponsiveContainer>
      
      <div>
        <InfoBox title="Optimization Summary" dataPoints={[
          { label: "Produced Solar Power", value: `${metadata.total_panel_prod_for_day} kWh` },
          { label: "Consumed Solar Power", value: `${(metadata.total_panel_prod_for_day - metadata.total_sold_kwh).toFixed(3)} kWh` },
          { label: "Export / Sold Power", value: `${metadata.total_sold_kwh} kWh` },
          { label: "Peak Solar Production", value: `${Math.max(...processedOptimizationData.map(d => d.panelPower)).toFixed(0)} W` }
        ]} />
      </div>
    </>
  );
};

// Data processing function for PV optimization data
const processPVOptimizationData = (pvData) => {
  return Object.entries(pvData).map(([time, data]) => {
    const gridPower = data.grid_power || 0;
    const panelPower = data.panel_power || 0;
    const activeDevices = data.active_devices || [];
    
    // Calculate total device power capacity
    const totalDevicePower = activeDevices.reduce((sum, device) => sum + (device.power_rating || 0), 0);
    
    // Use actual consumption from panels data directly (in kWh)
    const actualPanelConsumption = data.consumption_from_panels * 1000 || 0;
    
    return {
      time: new Date(time),
      gridPower,
      panelPower,
      totalDevicePower,
      actualPanelConsumption,
      deviceCount: activeDevices.length,
      activeDevices: activeDevices.map(d => d.device_name).join(', ') || 'None'
    };
  });
};

// Custom tooltip for optimization chart
const CustomOptimizationTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const time = format(new Date(label), 'HH:mm');
    
    return (
      <div style={{
        backgroundColor: 'white',
        padding: '12px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>{`Time: ${time}`}</p>
        <p style={{ margin: '4px 0', color: '#82ca9d' }}>
          {`Solar Production: ${data.panelPower.toFixed(0)}W`}
        </p>
        <p style={{ margin: '4px 0', color: data.gridPower < 0 ? '#ff4444' : '#4caf50' }}>
          {`Grid Power: ${data.gridPower.toFixed(0)}W`}
        </p>
        <p style={{ margin: '4px 0', color: '#ffb74d' }}>
          {`Device Capacity: ${data.totalDevicePower}W (${data.deviceCount} devices)`}
        </p>
        <p style={{ margin: '4px 0', color: '#64b5f6' }}>
          {`Actual Panel Consumption: ${data.actualPanelConsumption.toFixed(3)} kWh`}
        </p>
        <p style={{ margin: '4px 0', fontSize: '11px', color: '#666' }}>
          {`Devices: ${data.activeDevices}`}
        </p>
      </div>
    );
  }
  return null;
};

// Legend for optimization chart
const customizedOptimizationLegend = [
  { value: 'Panel Power', type: 'line', color: '#82ca9d' },
  { value: 'Grid Power (+ import, - export)', type: 'line', color: '#8884d8' },
  { value: 'Device Capacity', type: 'line', color: '#ffb74d' },
  { value: 'Actual Panel Consumption', type: 'rect', color: '#64b5f6' }
];


export default HeatingCharts;
